import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=567afdf2&scoped=true"
import script from "./ReportHeader.vue?vue&type=script&lang=js"
export * from "./ReportHeader.vue?vue&type=script&lang=js"
import style0 from "./ReportHeader.vue?vue&type=style&index=0&id=567afdf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567afdf2",
  null
  
)

export default component.exports